import React, { useState } from "react";
import "../Styles/Home.css";
import logoMain from "../Assets/logoNH7.png";
import titleMap from "../Assets/festivalMap/titlemap.png";
import back from "../Assets/back.svg";
import MainMap from "../Assets/festivalMap/map.png";
import footerMap from "../Assets/festivalMap/footermap.png";



const FestivalMap = () => {


  return (
    <div>
      <div>
          <a href="/" className="fBack">
            <img src={back} className="backBtn" alt="back button"></img>
          </a>
        </div>
      <section className="">
            <div className="content_div_Festivalmap">
            <a href="/">
              <img src={logoMain} className="logoMain_pages" alt="nh7 Weekender logo"></img>
            </a>
              <div className="Festivalmap_block">
                <img src={titleMap} className="map_title" alt="festival map title"></img>
                <img src={MainMap} className="festival_map" alt="festival map"></img>
              </div>
              <img src={footerMap} className="footer_map" alt="festival map"></img>
          </div>
      </section>
    </div>
  );
};

export default FestivalMap;
